module.exports = __webpack_public_path__ + "static/media/298211.89be48b7.png";